import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
// import remed from "../../Assets/Projects/remed.png";
import step from "../../Assets/Projects/stepfunction_success.png";
// import food from "../../Assets/Projects/food.png";
// import sales from "../../Assets/Projects/sales.png";
// import speed from "../../Assets/Projects/speed.png";
// import football from "../../Assets/Projects/football.png";
// import churn from "../../Assets/Projects/churn.png";
// import call from "../../Assets/Projects/call.png";
import bot from "../../Assets/Projects/chatbot.png";
// import recommend from "../../Assets/Projects/recommend.png";
// import gifted from "../../Assets/Projects/gifted.png";
import alm from "../../Assets/Projects/ALMFig.png";
import design from "../../Assets/Projects/design.png";
import aya from "../../Assets/Projects/Aya.png";
import qa from "../../Assets/Projects/QAimages.jfif";
import Particle from "../Particle";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={design}
              isBlog={false}
              title="Project Portfolio Design"
              description="This showcases selected creative technical projects and research initiatives, highlighting my contributions across AI"
              // ghLink="https://github.com/Olympiah/ALM-Bench.git"
              demoLink="https://mycreativeprojects.my.canva.site/portfolio-ai"
            />
          </Col>
           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={alm}
              isBlog={false}
              title="All Language Matters:Evaluating LMMs on Culturally Diverse 100 Languages"
              description="This project focused on creating a Cultural Mulitilingual and multimodal VQA benchmark LLM . In pursuit of culturally diverse global multimodal models, our proposed All Languages Matter Benchmark represents the largest 
              and most comprehensive effort to date for evaluating LMMs across 100 languages. "
              ghLink="https://github.com/Olympiah/ALM-Bench.git"
              // demoLink="https://sphera-app.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={qa}
              isBlog={false}
              title="QA Portfolio"
              description="This is a portfolio specifically focused on QA and sample work"
              // ghLink="https://github.com/Olympiah/sphera.git"
              demoLink="https://qa-portfolio-flax-iota.vercel.app"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bot}
              isBlog={false}
              title="AI Powered Enterprise Chatbot"
              description="This project was completed during the IBM Watson AI hackathon 2024. This is an Enterprise Chatbot Assistant that utilizes RAG to obtain up-to date company information"
              ghLink="https://github.com/Olympiah/sphera.git"
              demoLink="https://sphera-app.vercel.app/"
            />
          </Col>
           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={aya}
              isBlog={false}
              title="Aya Expanse"
              description=" I was part of the release team for the project Aya Expanse, a state-of-the-art multilingual family of models to help close the language gap with AI"
              // ghLink="https://github.com/Olympiah/ALM-Bench.git"
              demoLink="https://huggingface.co/CohereLabs/aya-expanse-8b"
            />
          </Col>
         
          {/*<Col md={4} className="project-card">
            <ProjectCard
              imgPath={speed}
              isBlog={false}
              title="EyeSpeeD"
              description=" Real-Time Vehicle Speed Estimation System that utilizes Object Detection and Tracking."
              ghLink="https://github.com/Olympiah/Need4Speed.git"
              // demoLink=""
            />
          </Col>
             
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={speed}
              isBlog={false}
              title="RAG EVALUATION"
              description=" Real-Time Vehicle Speed Estimation System that utilizes Object Detection and Tracking."
              ghLink="https://github.com/Olympiah/Need4Speed.git"
              // demoLink=""
            />
          </Col> */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={step}
              isBlog={false}
              title="An ML Workflow on AWS SageMaker"
              description="This project  utilizes the AWS services to train a model, deploy a model, AWS Lambda functions, and  Step functions to compose your model and services into an event-driven application"
              ghLink="https://github.com/Olympiah/Image-Classification-model.git"
            />
          </Col>

          {/*<Col md={4} className="project-card">
            <ProjectCard
              imgPath={churn}
              isBlog={true}
              title="Customer Churn Analysis at PhoneNow"
              description="In this project I perform customer churn risk analysis for the company PhoneNow as part of PWC Power BI virtual internship. I identify the key performance metrics, explore the customer profiles and lastly perform risk analysis to be able to make informed business decisions that I can share with the risk management team."
              ghLink="https://app.powerbi.com/view?r=eyJrIjoiMDVkMjhkNTctZTIyMi00MGQ0LWFiYmMtNWY5MzFhMzk3ODRkIiwidCI6ImVmOGNjODYzLTIxNDAtNDFiZS1iN2M1LTQzNjQ5NTkxNWRiZSJ9"
              // demoLink="https://app.powerbi.com/reportEmbed?reportId=e64da733-6a0e-4690-a64f-28d94eade3c1&autoAuth=true&ctid=ef8cc863-2140-41be-b7c5-436495915dbe"
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gifted}
              isBlog={false}
              title="Gifted Hearts Foundation"
              description="This is a website built, designed, and supported by Wix for our non-profit charity organization (Gifted HeartsKE)."
              // ghLink=""
              demoLink="https://olympiahot.wixsite.com/giftedheartske"
            />
          </Col> 
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={recommend}
              isBlog={false}
              title="Movie Muse (Movie Recommendation System)"
              description="This is a project I did to enhance my software development skills while also delving into Natural Language Processing. The flask app is built based on
                          content-based recommendation and sentiment analysis."
              ghLink="https://github.com/Olympiah/Recommendation-System.git"
              // demoLink=""
            />
          </Col> */}
          {/*<Col md={4} className="project-card">
            <ProjectCard
              imgPath={call}
              isBlog={true}
              title="Call Center Analysis"
              description="In this project I identify various key performance metrics at call centers in order to optimize operations i.e. customer satisfaction, agent hold time etc."
              // demoLink="https://app.powerbi.com/reportEmbed?reportId=bf0c7fd0-b344-4659-8d8f-e769bdc6ebb2&autoAuth=true&ctid=ef8cc863-2140-41be-b7c5-436495915dbe",
              ghLink="https://app.powerbi.com/view?r=eyJrIjoiNDAzZWJmMTUtZDhjNS00ZWU4LTkxNTItOWNiNjhjMzcxZDM4IiwidCI6ImVmOGNjODYzLTIxNDAtNDFiZS1iN2M1LTQzNjQ5NTkxNWRiZSJ9"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sales}
              isBlog={true}
              title="Company Sales Visualization"
              description="This is a project that showcases my analysis and visualization skills using POWER BI. I used SQL workbench as my data source and created interractive dashboards  "
              ghLink="https://app.powerbi.com/reportEmbed?reportId=82ea9e15-3d40-49f9-a3f8-a7bd44916658&autoAuth=true&ctid=ef8cc863-2140-41be-b7c5-436495915dbe"
              // demoLink="https://app.powerbi.com/reportEmbed?reportId=82ea9e15-3d40-49f9-a3f8-a7bd44916658&autoAuth=true&ctid=ef8cc863-2140-41be-b7c5-436495915dbe"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={remed}
              isBlog={false}
              title="RemeD Mobile"
              description="This is a mobile application built with react native whose main objective is was to create a platform for patience to have doctor's consultation virtually during the COVID Pandemic. It mainly focuses on patients with chronic diseases"
              ghLink="https://github.com/Olympiah/remed_mobile.git"
              // demoLink=""
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={football}
              isBlog={true}
              title="English Premier League Analysis"
              description="In this project I perform exploratory/descriptive analysis on football teams in the EPL with foucs on Man United statistics"
              // ghLink=""
              ghLink="https://app.powerbi.com/view?r=eyJrIjoiNjQzNGQxYzctZjRmNy00NTA4LTkwMWEtYTI0NzU1ODFhYjEwIiwidCI6ImVmOGNjODYzLTIxNDAtNDFiZS1iN2M1LTQzNjQ5NTkxNWRiZSJ9"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={food}
              isBlog={false}
              title="FooD App"
              description="This is a mobile app built using react native,expo and firebase as the database. I took inspiration from the uber eats app. It showcases my front-end development skills."
              ghLink="https://github.com/Olympiah/FOODAPP.git"
            />
          </Col> */}

          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
